export enum TransferInfoModalTestIds {
  MAIN_ACTION = 'trx_modal_main',
  SECONDARY_ACTION = 'trx_modal_sec',
}
